export default "__VITE_ASSET__D9XW_FYz__"